import { z } from 'zod';

export const loginSchema = z.object({
  correo: z.string().min(1, 'Ingrese su correo').email('Ingrese un correo válido'),
  contrasena: z.string().min(1, 'Ingrese su contraseña'),
});

export type LoginFormValues = z.infer<typeof loginSchema>;